
export default function ServiceAreas() {
  const regions = [
    {
      name: 'Central New Jersey',
      cities: [
        'Monmouth County',
        'Middlesex County',
        'Mercer County',
        'Somerset County',
        'Hunterdon County',
      ],
      icon: 'ri-map-pin-line',
    },
    {
      name: 'Shore Region',
      cities: [
        'Ocean County',
        'Atlantic County',
        'Cape May County',
        'Long Beach Island',
        'Point Pleasant',
      ],
      icon: 'ri-map-pin-2-line',
    },
    {
      name: 'North Jersey',
      cities: [
        'Bergen County',
        'Essex County',
        'Passaic County',
        'Morris County',
        'Hudson County',
      ],
      icon: 'ri-map-pin-3-line',
    },
    {
      name: 'Northeast Jersey',
      cities: [
        'Union County',
        'Warren County',
        'Sussex County',
        'Newark',
        'Jersey City',
      ],
      icon: 'ri-map-pin-line',
    },
    {
      name: 'South Jersey',
      cities: [
        'Burlington County',
        'Camden County',
        'Gloucester County',
        'Salem County',
        'Cumberland County',
      ],
      icon: 'ri-map-pin-2-line',
    },
    {
      name: 'Greater NJ Area',
      cities: ['Trenton', 'Princeton', 'Edison', 'Woodbridge', 'Toms River'],
      icon: 'ri-map-pin-3-line',
    },
  ];

  return (
    <section id="service-areas" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-teal-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-map-2-line text-teal-600 text-lg"></i>
            <span className="text-teal-700 text-sm font-semibold">Service Areas</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Proudly Serving the Entire Garden State
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Garden State Junk Removal has been serving communities across all of New Jersey since
            1998. From the Shore to North Jersey and everywhere in between, we are your trusted local
            junk removal experts.
          </p>
        </div>

        {/* Regions Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {regions.map((region, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                <i className={`${region.icon} text-teal-600 text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{region.name}</h3>
              <div className="space-y-2">
                {region.cities.map((city, cityIndex) => (
                  <div key={cityIndex} className="flex items-center space-x-2 text-gray-600">
                    <i className="ri-checkbox-circle-fill text-teal-600 text-sm"></i>
                    <span className="text-sm">{city}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Map Section */}
        <div className="bg-white rounded-2xl overflow-hidden shadow-xl">
          <div className="aspect-video w-full">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1558516.7013803!2d-75.56274!3d40.0583!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c0fb959e00409f%3A0x2cd27b07f83f6d8d!2sNew%20Jersey!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Garden State Junk Removal Service Areas - All of New Jersey"
            ></iframe>
          </div>
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-8 md:p-12">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">Serving All of New Jersey</h3>
            <p className="text-teal-100 text-lg mb-6 max-w-2xl mx-auto">
              No matter where you are in the Garden State, we have got you covered. Give us a call today
              for fast, reliable junk removal service anywhere in New Jersey.
            </p>
            <a
              href="tel:+19089021076"
              className="inline-flex items-center space-x-2 bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors text-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-2xl"></i>
              <span>Call (908) 902-1076</span>
            </a>
          </div>
        </div>

        {/* Experience Badge */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-4 bg-white rounded-2xl px-8 py-6 shadow-lg">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center">
              <i className="ri-award-line text-teal-600 text-3xl"></i>
            </div>
            <div className="text-left">
              <div className="text-3xl font-bold text-gray-900">Since 1998</div>
              <div className="text-gray-600">Over 25 Years Serving the Garden State</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
